import { useQuery } from 'react-query';
import { useAuth } from '@clerk/clerk-react';

// For development, we'll use a mock subscription state
let mockSubscriptionActive = false;

export const setMockSubscription = (active: boolean) => {
  mockSubscriptionActive = active;
};

export const useSubscription = () => {
  const { getToken } = useAuth();

  return useQuery(
    ['subscription'],
    async () => {
      return {
        isActive: mockSubscriptionActive,
        plan: mockSubscriptionActive ? 'premium' : 'free',
        expiresAt: mockSubscriptionActive ? Date.now() + 30 * 24 * 60 * 60 * 1000 : null
      };
    },
    {
      refetchInterval: 1000, // Poll every second in development
    }
  );
};
